import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

let locale;
if (location.hostname.includes('musee') || location.hostname.includes('fr.upswell') ) {
    locale = 'fr';
} else {    
    locale = 'en';
}

// locale = 'fr'

const i18n = new VueI18n({
    locale: locale,
    fallbackLocale: 'en',
    messages: {
        en: require('/public/i18n/en.json'),
        fr: require('/public/i18n/fr.json')
    }
})

export default i18n
